import "./heroBanner.css";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

const HeroBanner = ({ srcBig, srcSmall, alt }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [useBigImage, setUseBigImage] = useState(window.innerWidth >= 768);
  
  // Handle responsive image selection
  useEffect(() => {
    const handleResize = () => {
      setUseBigImage(window.innerWidth >= 768);
    };
    
    // Set initial size
    handleResize();
    
    // Add resize listener
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Preload image
  useEffect(() => {
    // Reset loaded state when image source changes
    setImageLoaded(false);
    
    const imgSrc = useBigImage ? srcBig : srcSmall;
    const img = new Image();
    img.src = imgSrc;
    
    if (img.complete) {
      // Image is already cached
      setImageLoaded(true);
    } else {
      img.onload = () => setImageLoaded(true);
    }
    
    return () => {
      img.onload = null;
    };
  }, [srcBig, srcSmall, useBigImage]);

  return (
    <div className="hero-container">
      <img
        src={useBigImage ? srcBig : srcSmall}
        alt={alt}
        className={`banner-hero-img ${imageLoaded ? 'loaded' : ''}`}
        fetchpriority="high"
        loading="eager"
        onLoad={() => setImageLoaded(true)}
      />
    </div>
  );
};

HeroBanner.propTypes = {
  srcBig: PropTypes.string.isRequired,
  srcSmall: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

HeroBanner.defaultProps = {
  alt: "Banner kép", // Default alt text if none provided
};

export default HeroBanner;